var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 45,
    viewBox: "0 0 153 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.342 44.125H5.91489C2.80491 44.125 0.257812 41.6415 0.257812 38.6093V5.51482C0.257812 2.48254 2.80491 -0.000919342 5.91489 -0.000919342H147.342C150.452 -0.000919342 152.999 2.48254 152.999 5.51482V38.6093C152.999 41.6415 150.452 44.125 147.342 44.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.342 0.882975C149.961 0.882975 152.092 2.96103 152.092 5.51482V38.6093C152.092 41.163 149.961 43.2411 147.342 43.2411H5.91489C3.29566 43.2411 1.16436 41.163 1.16436 38.6093V5.51482C1.16436 2.96103 3.29566 0.882975 5.91489 0.882975H147.342ZM147.342 -0.000919342H5.91489C2.80491 -0.000919342 0.257812 2.48254 0.257812 5.51482V38.6093C0.257812 41.6415 2.80491 44.125 5.91489 44.125H147.342C150.452 44.125 152.999 41.6415 152.999 38.6093V5.51482C152.999 2.48254 150.452 -0.000919342 147.342 -0.000919342Z",
    fill: "#5A5A5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0716 8.31548C11.7392 8.6547 11.5469 9.18283 11.5469 9.86678V34.2629C11.5469 34.9469 11.7392 35.475 12.0716 35.8142L12.1536 35.8887L26.1746 22.2234V21.9008L12.1536 8.2355L12.0716 8.31548Z",
    fill: "url(#paint0_linear_13372_140034)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8404 26.7812L26.1719 22.2239V21.9012L30.846 17.3438L30.9507 17.4031L36.4861 20.474C38.0659 21.3455 38.0659 22.7796 36.4861 23.6566L30.9507 26.722L30.8404 26.7812Z",
    fill: "url(#paint1_linear_13372_140034)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9522 26.7221L26.1734 22.0626L12.0703 35.8147C12.595 36.3525 13.4506 36.4173 14.4237 35.8796L30.9522 26.7221Z",
    fill: "url(#paint2_linear_13372_140034)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9522 17.405L14.4237 8.24753C13.4506 7.71526 12.595 7.78007 12.0703 8.31785L26.1734 22.0645L30.9522 17.405Z",
    fill: "url(#paint3_linear_13372_140034)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9089 11.2995C53.9089 12.2207 53.6261 12.9584 53.0688 13.5086C52.4282 14.1608 51.5937 14.489 50.5712 14.489C49.594 14.489 48.7596 14.1553 48.075 13.4975C47.3891 12.8301 47.0469 12.0111 47.0469 11.0306C47.0469 10.0502 47.3891 9.23112 48.075 8.56924C48.7596 7.90597 49.594 7.57227 50.5712 7.57227C51.0577 7.57227 51.5216 7.67017 51.9643 7.85219C52.4055 8.03559 52.7648 8.2838 53.025 8.58992L52.4338 9.17183C51.9798 8.64921 51.3618 8.39135 50.5712 8.39135C49.8584 8.39135 49.2404 8.63405 48.7157 9.12357C48.1967 9.61447 47.9364 10.2502 47.9364 11.0306C47.9364 11.8111 48.1967 12.4523 48.7157 12.9432C49.2404 13.4272 49.8584 13.6754 50.5712 13.6754C51.3279 13.6754 51.9643 13.4272 52.4664 12.9377C52.7973 12.6136 52.9854 12.1669 53.0349 11.596H50.5712V10.799H53.858C53.8976 10.9713 53.9089 11.1382 53.9089 11.2995Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.045257,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1176 8.53289H56.0303V10.6289H58.8135V11.4259H56.0303V13.5219H59.1176V14.3341H55.1562V7.7207H59.1176V8.53289Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.045257,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8068 14.3341H61.9328V8.53289H60.0391V7.7207H64.7019V8.53289H62.8068V14.3341Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.045257,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0703 14.3341V7.7207H68.9429V14.3341H68.0703Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.045257,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8146 14.3341H71.9476V8.53289H70.0469V7.7207H74.7154V8.53289H72.8146V14.3341Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.045257,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5484 13.4865C82.8795 14.1553 82.0507 14.489 81.0621 14.489C80.0679 14.489 79.2392 14.1553 78.5702 13.4865C77.9027 12.8191 77.5703 12 77.5703 11.0306C77.5703 10.0612 77.9027 9.24216 78.5702 8.57475C79.2392 7.90597 80.0679 7.57227 81.0621 7.57227C82.0451 7.57227 82.8738 7.90597 83.5428 8.58027C84.216 9.25319 84.5483 10.0668 84.5483 11.0306C84.5483 12 84.216 12.8191 83.5484 13.4865ZM79.2165 12.9322C79.72 13.4272 80.3324 13.6754 81.0621 13.6754C81.7862 13.6754 82.4043 13.4272 82.9021 12.9322C83.4042 12.4371 83.6587 11.8015 83.6587 11.0306C83.6587 10.2598 83.4042 9.62412 82.9021 9.12908C82.4043 8.63405 81.7862 8.38584 81.0621 8.38584C80.3324 8.38584 79.72 8.63405 79.2165 9.12908C78.7145 9.62412 78.4599 10.2598 78.4599 11.0306C78.4599 11.8015 78.7145 12.4371 79.2165 12.9322Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.045257,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7656 14.3341V7.7207H86.8263L90.1244 12.8641H90.1626L90.1244 11.5927V7.7207H90.997V14.3341H90.0862L86.6326 8.93692H86.5944L86.6326 10.2138V14.3341H85.7656Z",
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.045257,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.351 23.9955C74.6936 23.9955 72.5227 25.9674 72.5227 28.688C72.5227 31.3866 74.6936 33.3792 77.351 33.3792C80.0141 33.3792 82.185 31.3866 82.185 28.688C82.185 25.9674 80.0141 23.9955 77.351 23.9955ZM77.351 31.5314C75.8929 31.5314 74.6384 30.3579 74.6384 28.688C74.6384 26.9961 75.8929 25.8433 77.351 25.8433C78.8091 25.8433 80.0692 26.9961 80.0692 28.688C80.0692 30.3579 78.8091 31.5314 77.351 31.5314ZM66.8161 23.9955C64.153 23.9955 61.9878 25.9674 61.9878 28.688C61.9878 31.3866 64.153 33.3792 66.8161 33.3792C69.4778 33.3792 71.6444 31.3866 71.6444 28.688C71.6444 25.9674 69.4778 23.9955 66.8161 23.9955ZM66.8161 31.5314C65.3566 31.5314 64.0979 30.3579 64.0979 28.688C64.0979 26.9961 65.3566 25.8433 66.8161 25.8433C68.2742 25.8433 69.5287 26.9961 69.5287 28.688C69.5287 30.3579 68.2742 31.5314 66.8161 31.5314ZM54.28 25.4337V27.4277H59.1635C59.0207 28.5419 58.6388 29.3609 58.0533 29.9318C57.3405 30.6213 56.2303 31.3866 54.28 31.3866C51.2747 31.3866 48.9214 29.0217 48.9214 26.0915C48.9214 23.1612 51.2747 20.7964 54.28 20.7964C55.905 20.7964 57.0874 21.4155 57.96 22.2181L59.4011 20.8129C58.1806 19.6767 56.557 18.8038 54.28 18.8038C50.1589 18.8038 46.6953 22.0733 46.6953 26.0915C46.6953 30.1097 50.1589 33.3792 54.28 33.3792C56.5075 33.3792 58.1806 32.6676 59.4959 31.3328C60.8437 30.0187 61.2637 28.1709 61.2637 26.6789C61.2637 26.2156 61.2241 25.7895 61.1534 25.4337H54.28ZM105.542 26.9795C105.144 25.9301 103.918 23.9955 101.42 23.9955C98.9455 23.9955 96.8849 25.8971 96.8849 28.688C96.8849 31.3163 98.9242 33.3792 101.658 33.3792C103.869 33.3792 105.144 32.065 105.669 31.2997L104.028 30.2338C103.481 31.0143 102.736 31.5314 101.658 31.5314C100.587 31.5314 99.8195 31.0529 99.3273 30.1097L105.764 27.5132L105.542 26.9795ZM98.9794 28.5418C98.9242 26.7327 100.421 25.806 101.493 25.806C102.333 25.806 103.045 26.2156 103.283 26.8016L98.9794 28.5418ZM93.748 33.0937H95.8638V19.3044H93.748V33.0937ZM90.2831 25.0407H90.2123C89.7371 24.4919 88.8306 23.9955 87.6822 23.9955C85.2723 23.9955 83.0689 26.0584 83.0689 28.7032C83.0689 31.3328 85.2723 33.3792 87.6822 33.3792C88.8306 33.3792 89.7371 32.8786 90.2123 32.3132H90.2831V32.9862C90.2831 34.7802 89.3001 35.744 87.7147 35.744C86.4221 35.744 85.6202 34.8339 85.2893 34.0686L83.4493 34.8174C83.9797 36.0612 85.384 37.5918 87.7147 37.5918C90.1954 37.5918 92.2885 36.1687 92.2885 32.7062V24.2809H90.2831V25.0407ZM87.8632 31.5314C86.4051 31.5314 85.1846 30.3414 85.1846 28.7032C85.1846 27.0498 86.4051 25.8433 87.8632 25.8433C89.3001 25.8433 90.433 27.0498 90.433 28.7032C90.433 30.3414 89.3001 31.5314 87.8632 31.5314ZM115.447 19.3044H110.387V33.0937H112.497V27.8689H115.447C117.791 27.8689 120.089 26.2156 120.089 23.586C120.089 20.9577 117.785 19.3044 115.447 19.3044ZM115.502 25.9508H112.497V21.2225H115.502C117.078 21.2225 117.977 22.498 117.977 23.586C117.977 24.6533 117.078 25.9508 115.502 25.9508ZM128.546 23.9693C127.022 23.9693 125.436 24.6257 124.784 26.0805L126.657 26.8458C127.06 26.0805 127.801 25.8322 128.584 25.8322C129.679 25.8322 130.789 26.4734 130.806 27.6056V27.7503C130.424 27.5352 129.607 27.2167 128.601 27.2167C126.585 27.2167 124.53 28.2992 124.53 30.3193C124.53 32.1671 126.181 33.3571 128.038 33.3571C129.458 33.3571 130.242 32.7324 130.734 32.0057H130.806V33.0716H132.844V27.7821C132.844 25.3372 130.972 23.9693 128.546 23.9693ZM128.292 31.5259C127.601 31.5259 126.64 31.1922 126.64 30.3579C126.64 29.2906 127.839 28.8811 128.877 28.8811C129.806 28.8811 130.242 29.081 130.806 29.3444C130.641 30.6213 129.513 31.5259 128.292 31.5259ZM140.269 24.2713L137.843 30.249H137.771L135.264 24.2713H132.988L136.756 32.6249L134.606 37.2733H136.811L142.617 24.2713H140.269ZM121.248 33.0937H123.364V19.3044H121.248V33.0937Z",
    fill: "#1A1A1A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13372_140034",
    x1: 24.9298,
    y1: 34.517,
    x2: 6.4222,
    y2: 15.5352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13372_140034",
    x1: 38.5432,
    y1: 22.061,
    x2: 11.1665,
    y2: 22.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13372_140034",
    x1: 28.3536,
    y1: 19.5297,
    x2: 3.2559,
    y2: -6.21115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13372_140034",
    x1: 8.52027,
    y1: 43.933,
    x2: 19.7275,
    y2: 32.4387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLight);
export default __webpack_public_path__ + "static/media/google-play-light.c72bdb946a594fed776810d1444f5ba6.svg";
export { ForwardRef as ReactComponent };